<a [routerLink]="['/']" queryParamsHandling="preserve">
  <h1>AO Editor</h1>
</a>

<nav class="navBar" *ngIf="missionService.userSession">
  <!--<a [routerLink]="['/dce']">Edition DCE</a>-->
  <!--<app-ao-search-bar id="aoSearchBar" [placeHolder]="'Rechercher un appel d\'offres'"-->
                     <!--[searchBarType]="'ao'" class="flexGrow1"></app-ao-search-bar>-->
  <a [routerLink]="['/ao']" queryParamsHandling="preserve" routerLinkActive="activeItem">Edition d'Avis</a>
  <a [routerLink]="['/ao-pub']" *ngIf="missionService.userSession.gotAllRights" queryParamsHandling="preserve" routerLinkActive="activeItem">Rédaction de marchés publics</a>
  <a [routerLink]="['/ao-priv']" *ngIf="missionService.userSession.gotAllRights" queryParamsHandling="preserve" routerLinkActive="activeItem">Rédaction de marchés privés</a>
  <a [routerLink]="['/search']" *ngIf="missionService.userSession.gotAllRights" queryParamsHandling="preserve" routerLinkActive="activeItem">Recherche</a>
  <a [routerLink]="['/profil-ach']" *ngIf="missionService.userSession.gotAllRights" queryParamsHandling="preserve" routerLinkActive="activeItem">Profils acheteurs</a>
  <a [routerLink]="['/profil-att']" *ngIf="missionService.userSession.gotAllRights" queryParamsHandling="preserve" routerLinkActive="activeItem">Profils attributaires</a>
  <a [routerLink]="['/sources']" *ngIf="missionService.userSession.gotAllRights" queryParamsHandling="preserve" routerLinkActive="activeItem">Sources</a>
  <div (click)="disconnect()" class="disconnectBtn" *ngIf="missionService.userSession">
    <span *ngIf="missionService.userSession.userName">{{missionService.userSession.userName}}</span>
    <span>Déconnexion</span>
  </div>
</nav>


<!--
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
-->
